import Vue from 'vue'
import Router from 'vue-router'
import HowTo from '@/pages/HowTo'
import TokenInvalid from '@/pages/TokenInvalid'
import TokenExpired from '@/pages/TokenExpired'
import TokenDoesntExist from '@/pages/TokenDoesntExist'
import Verification from '@/pages/Verification'
import Psap from '@/pages/Psap'
import Meta from 'vue-meta'

Vue.use(Router)
Vue.use(Meta)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/howto'
    },
    {
      path: '/howto',
      name: 'HowTo',
      component: HowTo
    },
    {
      path: '/token-invalid',
      name: 'TokenInvalid',
      component: TokenInvalid
    },
    {
      path: '/token-expired',
      name: 'TokenExpired',
      component: TokenExpired
    },
    {
      path: '/token-doesnt-exist',
      name: 'TokenDoesntExist',
      component: TokenDoesntExist
    },
    {
      path: '/verification',
      name: 'Verification',
      component: Verification
    },
    {
      path: '/psap',
      name: 'Psap',
      component: Psap
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js